import { Education } from "../Types/Education";
import { Lang } from "../Types/Lang";

type Props = {
  title: string;
  propList: Education[];
  lang: Lang;
};

const EducationComponent = ({ propList, lang, title }: Props) => {
  return (
    <section className="cv-section">
      <div className="cv-card space-y-5">
        <h2 className="cv-heading">{title}</h2>

        <div className="cv-timeline">
          {propList.map((education, i) => (
            <article key={i} className="cv-timeline-item space-y-2">
              <span className="cv-timeline-dot" aria-hidden="true" />
              <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
                <h3 className="cv-subheading">{education.title[lang]}</h3>
                <span className="cv-meta">
                  {education.start} – {education.end ?? (lang === "da" ? "Nu" : "Present")}
                </span>
              </div>
              <p className="cv-text">{education.place[lang]}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationComponent;
